import useLoginInitialStates from "./login";

const useInitialStates = () => {
    return {
        useLoginInitialStates
    };
}

export default useInitialStates;